import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const PopoverContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: ${pxToRem(320)};
  border-radius: ${theme.borderRadius.md};
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
export const Header = styled.div `
  display: flex;
  padding: ${theme.spacing.xl};
  padding-right: ${theme.spacing['2xl']};
`;
export const Body = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.xl};
`;
export const Footer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.xl};
`;
export const Divider = styled.div `
  width: 100%;
  height: ${pxToRem(1)};
  background-color: ${theme.semantic.surface.sunken};
`;
export const Description = styled.div `
  overflow: hidden;
  display: -webkit-box;
  line-height: 140%;
  line-clamp: 4;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;
